import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../../../context/AuthContext'
import { ADMIN_RECRUITMENT_MODULES } from '../../../constants/adminModules'
import { ADMIN_DASHBOARD_PATH, adminPath } from '../../../constants/adminRoutes'

export function RecruitmentIndexRedirect() {
  const { hasModuleAccess } = useAuth()
  const first = ADMIN_RECRUITMENT_MODULES.find(({ key }) => hasModuleAccess(key))

  if (!first) {
    return <Navigate to={ADMIN_DASHBOARD_PATH} replace />
  }

  return <Navigate to={`/cp-login/recruitment/${first.route}`} replace />
}

export default function AdminRecruitmentLayout() {
  const { t } = useTranslation()
  const { hasModuleAccess } = useAuth()
  const location = useLocation()

  const visible = ADMIN_RECRUITMENT_MODULES.filter(({ key }) => hasModuleAccess(key))

  if (!visible.length) {
    return <Navigate to={ADMIN_DASHBOARD_PATH} replace />
  }

  const active = ADMIN_RECRUITMENT_MODULES.find(
    ({ route }) =>
      location.pathname === `/cp-login/recruitment/${route}` ||
      location.pathname.startsWith(`/cp-login/recruitment/${route}/`),
  )

  return (
    <div>
      {active ? (
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-primary">{t(active.labelKey)}</h1>
          {active.route === 'applications' ? (
            <p className="mt-2 text-text/60">{t('admin.recruitment.subtitle')}</p>
          ) : null}
        </div>
      ) : null}
      <Outlet />
    </div>
  )
}
